import { Component, input, output, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserData } from '../services/auth.service';

@Component({
  selector: 'app-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive
  ],
  template: `
    <mat-nav-list class="nav-list">
      <a mat-list-item routerLink="/dashboard" routerLinkActive="active-link" (click)="closeSidenav.emit()">
        <mat-icon matListItemIcon>dashboard</mat-icon>
        @if (!iconOnly()) {
          <span matListItemTitle>Dashboard</span>
        }
      </a>

      <a mat-list-item routerLink="/trips" routerLinkActive="active-link" (click)="closeSidenav.emit()">
        <mat-icon matListItemIcon>directions_car</mat-icon>
        @if (!iconOnly()) {
          <span matListItemTitle>My Trips</span>
        }
      </a>

      <a mat-list-item routerLink="/frequent-places" routerLinkActive="active-link" (click)="closeSidenav.emit()">
        <mat-icon matListItemIcon>place</mat-icon>
        @if (!iconOnly()) {
          <span matListItemTitle>Frequent Places</span>
        }
      </a>

      @if (isAdmin() || isManager() || isAccounting()) {
        @if (!iconOnly()) {
          <mat-divider></mat-divider>
          <div mat-subheader>Management</div>
        }
        
        <a mat-list-item routerLink="/reports" routerLinkActive="active-link" (click)="closeSidenav.emit()">
          <mat-icon matListItemIcon>assessment</mat-icon>
          @if (!iconOnly()) {
            <span matListItemTitle>Reports</span>
          }
        </a>

        @if (isManager() || isAccounting()) {
            <a mat-list-item routerLink="/team" routerLinkActive="active-link" (click)="closeSidenav.emit()">
                <mat-icon matListItemIcon>group</mat-icon>
                @if (!iconOnly()) {
                  <span matListItemTitle>Team View</span>
                }
            </a>
            
            <a mat-list-item routerLink="/approvals" routerLinkActive="active-link" (click)="closeSidenav.emit()">
                <mat-icon matListItemIcon>fact_check</mat-icon>
                @if (!iconOnly()) {
                  <span matListItemTitle>Approvals</span>
                }
            </a>
        }
      }

      @if (isAdmin()) {
        @if (!iconOnly()) {
          <mat-divider></mat-divider>
          <div mat-subheader>Admin</div>
        }
        
        <a mat-list-item routerLink="/admin/settings" routerLinkActive="active-link" (click)="closeSidenav.emit()">
          <mat-icon matListItemIcon>settings</mat-icon>
          @if (!iconOnly()) {
            <span matListItemTitle>System Settings</span>
          }
        </a>
      }
    </mat-nav-list>
  `,
  styles: [`
    :host {
      display: block;
      transition: width 0.3s ease-in-out;
      overflow-x: hidden;
      white-space: nowrap;
    }

    .nav-list {
      padding-top: 0;
    }

    .active-link {
      background-color: rgba(255, 241, 0, 0.15);
      color: #000;
      border-left: 5px solid #fff100;
      font-weight: 600;
      
      mat-icon {
        color: #000 !important;
      }
    }

    .dark-theme {
      .active-link {
        background-color: rgba(255, 241, 0, 0.1);
        color: #fff100;
        
        mat-icon {
          color: #fff100 !important;
        }
      }
    }

    mat-divider {
      margin: 8px 0;
    }

    [mat-subheader] {
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #666;
    }

    .dark-theme [mat-subheader] {
      color: #aaa;
    }

    .mat-mdc-list-item {
      overflow: hidden;
    }
  `]
})
export class NavComponent {
  user = input<UserData | null>(null);
  iconOnly = input<boolean>(false);
  closeSidenav = output<void>();

  @HostBinding('class.icon-only')
  get isIconOnlyClass() {
    return this.iconOnly();
  }

  isAdmin(): boolean {
    return this.user()?.role === 'admin';
  }

  isManager(): boolean {
    return this.user()?.role === 'manager' || this.user()?.role === 'admin';
  }

  isAccounting(): boolean {
    return this.user()?.role === 'accounting';
  }
}
